export const MINUTOS_POR_UNIDAD = { minutos: 1, horas: 60, dias: 1440 };

export function intervaloEnMinutos(cantidad, unidad) {
  const numero = Number(cantidad);
  const minutos = numero * MINUTOS_POR_UNIDAD[unidad];
  if (!Number.isInteger(numero) || numero < 1 || !Number.isSafeInteger(minutos) || minutos > 2147483647) {
    throw new Error("El tiempo de lectura debe ser una cantidad entera positiva dentro del rango permitido.");
  }
  return minutos;
}

export function mostrarIntervalo(minutos) {
  const valor = Number(minutos);
  if (Number.isInteger(valor) && valor > 0) {
    for (const unidad of ["dias", "horas", "minutos"]) {
      if (valor % MINUTOS_POR_UNIDAD[unidad] === 0)
        return { tiempoSensor: valor / MINUTOS_POR_UNIDAD[unidad], unidadTiempo: unidad };
    }
  }
  return { tiempoSensor: minutos ?? "", unidadTiempo: "minutos" };
}
